import { render } from "./InfosView.vue?vue&type=template&id=c38c36d4&scoped=true"
import script from "./InfosView.vue?vue&type=script&lang=js"
export * from "./InfosView.vue?vue&type=script&lang=js"

import "./InfosView.vue?vue&type=style&index=0&id=c38c36d4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kobayashi.y\\develop\\thxily_fastapi\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c38c36d4"]])

export default __exports__